import { combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "../services/apiSlice";
import authReducer from "./authSlice";
import categoryFilterReducer from "./categorySlice";
import mastersVrpFilterReducer from "./mastersVrpFiltersSlice";
import mastersCategoryFilterReducer from "./mastersCategoryFilterSlice";
import mastersVariantFilterReducer from "./mastersVariantFilterSlice";

import actionModalReducer from "./actionModalSlice";
import priorityModalReducer from "./priorityModalSlice";
import advertisementFilterReducer from "./advertisementFilterSlice";
import advertisementActionModalReducer from "./advertisementActionModalSlice";

import variantModalReducer from "./variantModalSlice";
import mediaPreviewReducer from "./mediaPreviewSlice";
import mastersVrpActionModalReducer from "./mastersVrpActionModalSlice";
import orderFilterReducer from "./orderFilterSlice";
import cancellationFilterReducer from "./cancellationFilterSlice";
import refundFilterReducer from "./refund/refundFilterSlice";
import orderActionModalReducer from "./orderActionModalSlice";
import retailerFilterReducer from "./retailer/retailerFilterSlice";
import retailerActionModalReducer from "./retailerActionModalSlice";
import modalReducer from "./modalSlice";
import orderIdReducer from "./orderIdSlice";
import couponFilterReducer from "./couponFilterSlice";
import productListReducer from "./productListFilterSlice";
import masterSpareFilterreducer from "./master/masterSpareSlice";
import inventorySpareFilterreducer from "./inventory/inventorySparesSlice";

import inventorySpareLotListFilterReducer from "./inventory/inventorySpareLotListSlice";
import blogFilterReducer from "./blog/blogFilterSlice";
import refundInitiationReducer from "./refund_initiation/refundFilterSlice";
import bulkSparesFilterReducer from "./bulk/bulkSparesFilterSlice";
import bulkSparesLotFilterReducer from "./bulk/bulkSparesLotFilterSlice";
import termsAndConditionsFilterReducer from "./termsAndConditions/termsAndConditionsFilterSlice";


const appReducer = combineReducers({
  auth: authReducer,
  categoryFilter: categoryFilterReducer,
  masterSpareFilter: masterSpareFilterreducer,
  inventorySpareFilter: inventorySpareFilterreducer,
  

  inventorySpareLotListFilter: inventorySpareLotListFilterReducer,
  bulkSparesFilter: bulkSparesFilterReducer,
  bulkSparesLotFilter: bulkSparesLotFilterReducer,
  orderFilter: orderFilterReducer,
  cancellationFilter: cancellationFilterReducer,
  refundFilter: refundFilterReducer,
  orderActionModal: orderActionModalReducer,
  retailerFilter: retailerFilterReducer,
  retailerActionModal: retailerActionModalReducer,
  modal: modalReducer,
  orderId: orderIdReducer,
  couponFilter: couponFilterReducer,
  productListFilter: productListReducer,

  actionModal: actionModalReducer,
  advertisementActionModal: advertisementActionModalReducer,

  termsAndConditionsFilter: termsAndConditionsFilterReducer,

  mastersVrpFilter: mastersVrpFilterReducer,
  mastersCategoryFilter: mastersCategoryFilterReducer,
  mastersVariantFilter: mastersVariantFilterReducer,
  mastersVrpActionModal: mastersVrpActionModalReducer,
  variantModal: variantModalReducer,
  priorityModal: priorityModalReducer,
  advertisementFilter: advertisementFilterReducer,
  blogFilter: blogFilterReducer,
  refundInitiationFilter: refundInitiationReducer,
  mediaPreview: mediaPreviewReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default appReducer;
